module.exports = __webpack_public_path__ + "media/packs/images/flags/ME-af5e6a9c8777dbaf8697f31755230fad.svg";